import React, { useEffect, useLayoutEffect } from "react";
import * as stylex from "@stylexjs/stylex";
import { ThemeProvider, DEFAULT_THEME } from "@zendeskgarden/react-theming";
import { ToastProvider } from "@zendeskgarden/react-notifications";
import { zendesk } from "./zendesk";
import { Root } from "./views/Root";
import { useTheme } from "./useTheme";
import { useAutoResize } from "./useAutoResize";
import "./styles/variables.stylex";
import { ZendeskThemeColors, ZendeskThemeVariables } from "./styles/variables.stylex";
import "./styles/bedrock.css";
const {
  PROD
} = import.meta.env;
function App() {
  const {
    base,
    themeObject
  } = useTheme();
  useAutoResize();
  useLayoutEffect(() => {
    if (PROD && !zendesk) {
      return;
    }
    const {
      className
    } = {
      0: {
        className: "sx-65nank sx-1odjw0f sx-n9heto sx-17e5z5g"
      },
      1: {
        className: "sx-65nank sx-1odjw0f sx-n9heto sx-17e5z5g sx-66dr3b sx-1ewbp64 sx-6c0k02 sx-1bfsv9u sx-1t0msmz"
      }
    }[!!(base === "dark") << 0];
    const classNames = className?.split(" ").filter(Boolean) ?? [];
    document.documentElement.classList.add(...classNames);
    return () => {
      document.documentElement.classList.remove(...classNames);
    };
  }, [base]);
  useEffect(() => {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ZENDESK_CLIENT = zendesk;
  }, []);

  // Render empty view in prod if accessed outside Zendesk iframe
  if (PROD && !zendesk) {
    return <div />;
  }
  return <>
      <ThemeProvider theme={themeObject}>
        <ToastProvider placementProps={placementProps} limit={1} zIndex={1}>
          <Root />
        </ToastProvider>
      </ThemeProvider>
    </>;
}
const topProps = {
  style: {
    top: DEFAULT_THEME.space.base * 3
  }
} as React.HTMLAttributes<HTMLDivElement>;
const bottomProps = {
  style: {
    bottom: DEFAULT_THEME.space.base * 3
  }
} as React.HTMLAttributes<HTMLDivElement>;
const placementProps = {
  "top-start": topProps,
  top: topProps,
  "top-end": topProps,
  "bottom-start": bottomProps,
  bottom: bottomProps,
  "bottom-end": bottomProps
};

/** Bootstraps the Zendesk app shell with theming, toasts, and the authenticated root view. */
export default App;